module.exports = __webpack_public_path__ + "media/images/partners/apps-for-good-2e0543aab9b5d1af61da848db7465ce3.svg";